class Request
{
    constructor() {
        this.id       = null;
        this.command  = null;
        this.data     = null;
    }
}

class Response
{
	static get OK() {
		return 200;
	}

	static get BAD_REQUEST() {
		return 400; // BAD REQUEST
	}

	static get UNAUTHORIZED() {
		return 403;
	}

	static get CONFLICT() {
		return 409; // CONFLICT (INSERT - Entity with same name already exists)
	}

	static get PAYLOAD_TOO_LARGE() {
		return 413; // Payload Too Large
	}

	static get ERROR() {
		return 500; // Internal Server Error
	}

    constructor() {
        this.cid  = null; // client id, -1 if used for subscription response (broadcasting)
        this.id   = null;
        this.code = null;
        this.data = null;
    }
}

class Role {

	static get ROOT() {
		return 0;
	}

	//noinspection JSUnusedGlobalSymbols
	static get POWERUSER() {
		return 1;
	}

	static get USER() {
		return 2;
	}

	static get GUEST() { // No rights before lift privilegies
		return 3;
	}
}

export {Request, Response, Role}



// WEBPACK FOOTER //
// ./src/script/ws/wsclasses.js